import VideoV2 from './component.jsx'
export default VideoV2
